<template>
    <div>
        <b-spinner variant="primary"
            class="spinStyle"
            v-show="showSpin"
            label="Text Centered"></b-spinner>
        <div class="dataTable fav-list">
            <b-table id="product-table"
                :fields="productFields"
                :items="prodcutItems"
                small
                bordered
                hover
                show-empty
                empty-text="没有找到匹配的记录"
                :busy="isTableBusy"
                caption-top>
                <template slot="table-caption">收藏列表</template>
                <template v-slot:cell(productImg)="row">
                    <img :src="row.item.productFinishImageFile.url"
                        width="30"
                        height="30">
                </template>
                <template v-slot:cell(orderQuantity)="row">
                    <b-form-input size="sm"
                        v-model="row.item.orderQuantity">
                    </b-form-input>
                </template>
                <template v-slot:cell(detailButton)="row">
                    <a href="#"
                        v-on:click="onProductDetail(row)">详情</a>
                    <span> / </span>
                    <a href="#" style="color: #dc4300;"
                        v-on:click="DeleteFav(row)">取消收藏</a>
                </template>
                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>

            </b-table>
        </div>
        <div class="pageControl">
            <b-pagination v-model="feSearch.limit.conditions.pageStart"
                style="margin-top:20px;"
                :total-rows="feSearch.limit.conditions.total"
                :per-page="feSearch.limit.conditions.pageLength"
                align="center"
                size="sm"
                ellipsis-text="..."
                first-text="首页"
                prev-text="上一页"
                next-text="下一页"
                last-text="尾页"
                limit="10"
                @change="onPageChange"></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import "@/style/global.css";
export default {
    name: "FavList",
    data() {
        return {
            showSpin: false,
            favList: [],
            isTableBusy: false,
            productFields: [
                { key: 'productImg', label: '缩图' },
                { key: 'productCode', label: '编码' },
                { key: 'productName', label: '品名' },
                { key: 'productSpec', label: '规格' },
                { key: 'brandName', label: '品牌' },
                { key: 'unitName', label: '单位' },
                { key: 'productPackageQuantity', label: '装箱量' },
                { key: 'productCurSalePrice', label: '单价' },
                // { key: 'productCurSaleWarehouseAmount', label: '现苗量' },
                { key: 'detailButton', label: '操作' }
            ],
            prodcutItems: [],
            feSearch: search.getSearchParams()
        };
    },
    mounted() {
        this.getFavList();
    },
    methods: {
        getFavList() {
            this.showSpin = true;
            api.webGetMyFavProducts().then(res => {
                this.showSpin = false;
                if (res.code === 0) {
                    this.favList = res.data.products;
                    this.feSearch.filters.enable = true;
                    search.globalRemoveFilterConditionKey(this.feSearch, 'productUuid');
                    this.feSearch.filters.conditions.push({
                        name: 'productUuid',
                        type: 'in',
                        value: JSON.stringify(this.favList)
                    });
                    this.getProductList();
                }
            });
        },
        DeleteFav(row) {
            this.isTableBusy = true;
            api.webDelProductFav({ productUuid: row.item.productUuid }).then(res => {
                this.isTableBusy = false;
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("取消收藏成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.getFavList();
                }
            });
        },
        getProductList() {
            this.isTableBusy = true;
            api.getProductList(this.feSearch).then(res => {
                this.isTableBusy = false;
                if (res.code === 0) {
                    this.prodcutItems = res.data.records;
                    this.prodcutItems.forEach(p => {
                        if (p.productFinishImageFile) {
                            p.productFinishImageFile = JSON.parse(p.productFinishImageFile);
                            p.productFinishImageFile.url = api.fileServer + p.productFinishImageFile.url;
                        }
                    });
                    search.globalSetFilterRecordCount(this.feSearch, res.data.filterRecordCount);
                }
            });
        },
        onPageChange(pageNum) {
            search.globalPageOnChange(this.feSearch, pageNum);
            this.getProductList();
        },
        onProductDetail(row) {
            this.$router.push({
                name: 'ProductList',
                query: {
                    productUuid: row.item.productUuid
                }
            });
        }
    }
};
</script>

<style>
/*收藏列表_标题修改样式*/	
.fav-list caption{
	font-weight: 600;
	color: #000000;
}
/*收藏列表_表头修改样式*/
.fav-list th{
	background-color: #fafafa !important;
	white-space: nowrap;
	line-height:40px;
	text-align: center;
	}	
/*收藏列表_页码修改样式*/	
.page-link{color:#757575 !important;}
 .page-link:hover{color: #00b151 !important;}
 .page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
 .pagination-sm .page-link{
 	padding: 5px 12px !important;
 	margin-top: 40px;
 	}	
 .page-link:focus{box-shadow: none !important;}	
</style>



// WEBPACK FOOTER //
// src/view/product/fav-list.vue